.discord-embed .discord-embed-fields {
	display: flex;
	flex-wrap: wrap;
	margin-top: 8px;
}
